var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "video-container" }, [
      _c("div", { staticClass: "video-wrapper" }, [
        _c("iframe", {
          staticClass: "video",
          attrs: {
            width: "100%",
            height: "700",
            src: _vm.getUrl(),
            frameborder: "0",
            allowfullscreen: "",
            allow: "vr"
          }
        })
      ]),
      _vm._v(" "),
      _vm.type === "Matterport"
        ? _c("div", { staticClass: "link" }, [
            _vm._v("\n            3D-Rundgang erstellt von "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.aerovision-pro.de/",
                  target: "_blank"
                }
              },
              [_vm._v("AeroVersion")]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }